const editorShellPath = "/tool-megafm-editor.html";

if (window.location.pathname.endsWith("/tool-megafm-index.html")) {
  const redirectUrl = new URL(window.location.href);
  redirectUrl.pathname = redirectUrl.pathname.replace(/\/tool-megafm-index\.html$/, editorShellPath);
  redirectUrl.search = "";
  redirectUrl.hash = "";
  window.location.replace(redirectUrl.toString());
}

const optionDefinitions = [
  { label: "Thru", note: 1, cc: 1, inverted: true },
  { label: "Ignore Preset Vol", note: 2, cc: 2 },
  { label: "MIDI Sync LFO 1", note: 3, cc: 3 },
  { label: "MIDI Sync LFO 2", note: 4, cc: 4 },
  { label: "MIDI Sync LFO 3", note: 5, cc: 5 },
  { label: "MIDI Sync Vib", note: 6, cc: 6 },
  { label: "MIDI Sync Arp", note: 7, cc: 7 },
  { label: "Pickup Mode", note: 8, cc: 8 },
  { label: "MPE Mode", note: 9, cc: 9 },
  { label: "Vel > LFO1 Depth", note: 10, cc: 10 },
  { label: "Mod > LFO2 Depth", note: 11, cc: 11 },
  { label: "AT > LFO3 Depth", note: 12, cc: 12 },
  { label: "Stereo CH3", note: 13, cc: 13 },
  { label: "New Unison Fat Tuning", note: 14, cc: 14 },
  { label: "Enable Extra Wide 3/4 Modes", note: 20, cc: 20 },
];

const state = {
  midiReady: false,
  foundDevice: false,
  firmware: null,
  awaitingReply: false,
  replyTimeoutId: null,
  listenerChannel: null,
};

const ui = {};
const firmwareRequirementMessage = "Requires firmware 3.0 and above.";

document.addEventListener("DOMContentLoaded", () => {
  cacheUi();
  buildOptionToggles();
  populateStaticSelects();
  bindEvents();
  renderDeviceState("Waiting for scan");
  setStatus("ready", "Starting MIDI", "Requesting browser MIDI access.");
  syncUiState();
  void enableMidi();
});

function cacheUi() {
  ui.refreshPortsButton = document.getElementById("refresh-ports");
  ui.readButton = document.getElementById("read-device");
  ui.writeButton = document.getElementById("write-device");
  ui.inputSelect = document.getElementById("midi-input");
  ui.outputSelect = document.getElementById("midi-output");
  ui.midiChannelSelect = document.getElementById("midi-channel");
  ui.bendUpSelect = document.getElementById("bend-up");
  ui.bendDownSelect = document.getElementById("bend-down");
  ui.ledBrightnessSelect = document.getElementById("led-brightness");
  ui.polyFatRangeSelect = document.getElementById("poly-fat-range");
  ui.optionsGrid = document.getElementById("options-grid");
  ui.statusMessage = document.getElementById("status-message");
  ui.deviceState = document.getElementById("device-state");
  ui.firmwareValue = document.getElementById("firmware-value");
}

function bindEvents() {
  ui.refreshPortsButton.addEventListener("click", refreshMidiPorts);
  ui.readButton.addEventListener("click", readDeviceSettings);
  ui.writeButton.addEventListener("click", writeDeviceSettings);
  ui.inputSelect.addEventListener("change", handlePortChange);
  ui.outputSelect.addEventListener("change", handlePortChange);
}

function buildOptionToggles() {
  const fragment = document.createDocumentFragment();

  optionDefinitions.forEach((definition) => {
    const wrapper = document.createElement("label");
    wrapper.className = "option-item";

    const copy = document.createElement("span");
    copy.className = "option-copy";

    const title = document.createElement("span");
    title.className = "option-title";
    title.textContent = definition.label;

    const index = document.createElement("span");
    index.className = "option-index";
    index.textContent = `Note ${definition.note} / CC ${definition.cc}`;

    copy.append(title, index);

    const toggleWrap = document.createElement("span");
    toggleWrap.className = "toggle-wrap";

    const input = document.createElement("input");
    input.type = "checkbox";
    input.className = "toggle-input";
    input.dataset.note = String(definition.note);
    input.dataset.cc = String(definition.cc);
    if (definition.inverted) {
      input.dataset.inverted = "true";
    }

    const visual = document.createElement("span");
    visual.className = "toggle-ui";
    visual.setAttribute("aria-hidden", "true");

    toggleWrap.append(input, visual);
    wrapper.append(copy, toggleWrap);
    fragment.append(wrapper);
  });

  ui.optionsGrid.replaceChildren(fragment);
  ui.optionInputs = Array.from(ui.optionsGrid.querySelectorAll(".toggle-input"));
}

function populateStaticSelects() {
  fillNumericSelect(ui.midiChannelSelect, 1, 16);
  fillNumericSelect(ui.bendUpSelect, 1, 48);
  fillNumericSelect(ui.bendDownSelect, 1, 48);

  const ledSteps = [
    "12%",
    "18%",
    "25%",
    "31%",
    "37%",
    "43%",
    "50%",
    "56%",
    "62%",
    "68%",
    "75%",
    "81%",
    "87%",
    "93%",
    "100%",
  ].map((label, index) => ({
    value: String(index),
    label,
  }));

  fillSelect(
    ui.ledBrightnessSelect,
    ledSteps,
    (item) => item.label,
    (item) => item.value,
  );

  fillSelect(
    ui.polyFatRangeSelect,
    [
      { value: "0", label: "Semitone" },
      { value: "1", label: "Octave" },
    ],
    (item) => item.label,
    (item) => item.value,
  );
}

function fillNumericSelect(select, start, endInclusive) {
  const values = Array.from(
    { length: endInclusive - start + 1 },
    (_, index) => start + index,
  );
  fillSelect(select, values, (value) => String(value), (value) => String(value));
}

function fillSelect(select, items, labelFor, valueFor) {
  select.replaceChildren();

  items.forEach((item) => {
    const option = document.createElement("option");
    option.value = valueFor(item);
    option.textContent = labelFor(item);
    select.append(option);
  });
}

async function enableMidi() {
  if (state.midiReady) {
    refreshMidiPorts();
    return;
  }

  setStatus("ready", "Requesting Access", "Waiting for browser MIDI permission.");

  try {
    await WebMidi.enable({ sysex: true });
    state.midiReady = true;

    WebMidi.addListener("connected", refreshMidiPorts);
    WebMidi.addListener("disconnected", refreshMidiPorts);

    refreshMidiPorts();
    setStatus("ready", "MIDI Ready", firmwareRequirementMessage);
  } catch (error) {
    setStatus(
      "error",
      "MIDI Error",
      error?.message || "Web MIDI could not be enabled.",
    );
  }

  syncUiState();
}

function refreshMidiPorts() {
  if (!state.midiReady) {
    syncUiState();
    return;
  }

  populatePortSelect(ui.inputSelect, WebMidi.inputs, "No MIDI inputs detected");
  populatePortSelect(ui.outputSelect, WebMidi.outputs, "No MIDI outputs detected");

  if (!WebMidi.inputs.length || !WebMidi.outputs.length) {
    setStatus("error", "Ports Missing", "Need one MIDI input and one MIDI output.");
  } else if (!state.foundDevice && !state.awaitingReply) {
    setStatus("ready", "Ports Ready", firmwareRequirementMessage);
  }

  handlePortChange();
  syncUiState();
}

function populatePortSelect(select, ports, emptyLabel) {
  const previousValue = select.value;
  select.replaceChildren();

  if (!ports.length) {
    const placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.textContent = emptyLabel;
    select.append(placeholder);
    select.disabled = true;
    return;
  }

  select.disabled = false;

  ports.forEach((port) => {
    const option = document.createElement("option");
    option.value = port.id;
    option.textContent = formatPortLabel(port);
    select.append(option);
  });

  const hasPrevious = ports.some((port) => port.id === previousValue);
  select.value = hasPrevious ? previousValue : ports[0].id;
}

function formatPortLabel(port) {
  return port.manufacturer ? `${port.name} · ${port.manufacturer}` : port.name;
}

function handlePortChange() {
  state.foundDevice = false;
  state.firmware = null;
  clearReplyTimeout();
  detachInputListener();
  renderDeviceState("Waiting for scan");
  ui.firmwareValue.textContent = "-";

  if (state.midiReady && hasSelectedPorts()) {
    setStatus("ready", "Ports Ready", firmwareRequirementMessage);
  }

  syncUiState();
}

function readDeviceSettings() {
  const input = getSelectedInput();
  const output = getSelectedOutput();

  if (!input || !output) {
    setStatus("error", "Ports Missing", "Select both MIDI ports.");
    return;
  }

  detachInputListener();
  state.listenerChannel = input.channels[16];
  state.listenerChannel.addListener("noteoff", handleDeviceReply);
  state.awaitingReply = true;
  state.foundDevice = false;
  state.firmware = null;
  renderDeviceState("Reading");
  ui.firmwareValue.textContent = "-";

  setStatus("ready", "Reading Device", "Waiting for MEGAfm reply.");

  const channel = output.channels[16];
  channel.sendControlChange(19, 82);
  channel.sendControlChange(19, 82, { time: "+20" });

  clearReplyTimeout();
  state.replyTimeoutId = window.setTimeout(() => {
    state.replyTimeoutId = null;
    if (!state.foundDevice) {
      detachInputListener();
      setStatus("error", "No Reply", "Check routing and firmware.");
      renderDeviceState("No reply");
      syncUiState();
    }
  }, 1800);

  syncUiState();
}

function handleDeviceReply(event) {
  if (!state.awaitingReply) {
    return;
  }

  const note = event.note.number;
  const value = event.data?.[2] ?? event.rawVelocity ?? 0;

  switch (note) {
    case 0:
      if (value === 3) {
        state.foundDevice = true;
        renderDeviceState("MEGAfm detected");
        setStatus(
          "success",
          "Device Detected",
          "Loading current settings.",
        );
        clearReplyTimeout();
        scheduleReplyCompletion();
      }
      break;
    case 82:
      state.firmware = { major: value, minor: state.firmware?.minor ?? null };
      updateFirmwareDisplay();
      if (state.foundDevice) {
        scheduleReplyCompletion();
      }
      break;
    case 83:
      state.firmware = { major: state.firmware?.major ?? null, minor: value };
      updateFirmwareDisplay();
      if (state.foundDevice) {
        scheduleReplyCompletion();
      }
      break;
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
    case 6:
    case 7:
    case 8:
    case 9:
    case 10:
    case 11:
    case 12:
    case 13:
    case 14:
    case 20:
      applyToggleFromDevice(note, value);
      if (state.foundDevice) {
        scheduleReplyCompletion();
      }
      break;
    case 15:
      ui.midiChannelSelect.value = String(value);
      if (state.foundDevice) {
        scheduleReplyCompletion();
      }
      break;
    case 16:
      ui.bendUpSelect.value = String(value);
      if (state.foundDevice) {
        scheduleReplyCompletion();
      }
      break;
    case 17:
      ui.bendDownSelect.value = String(value);
      if (state.foundDevice) {
        scheduleReplyCompletion();
      }
      break;
    case 18:
      ui.ledBrightnessSelect.value = String(value);
      if (state.foundDevice) {
        scheduleReplyCompletion();
      }
      break;
    case 19:
      ui.polyFatRangeSelect.value = String(value);
      if (state.foundDevice) {
        scheduleReplyCompletion();
      }
      break;
    default:
      break;
  }

  syncUiState();
}

function applyToggleFromDevice(note, value) {
  const input = ui.optionInputs.find((item) => Number(item.dataset.note) === note);
  if (!input) {
    return;
  }

  if (input.dataset.inverted === "true") {
    input.checked = value === 0;
    return;
  }

  input.checked = value > 0;
}

function writeDeviceSettings() {
  const output = getSelectedOutput();

  if (!output) {
    setStatus("error", "Output Missing", "Select a MIDI output.");
    return;
  }

  const channel = output.channels[16];

  ui.optionInputs.forEach((input) => {
    const cc = Number(input.dataset.cc);
    const isInverted = input.dataset.inverted === "true";
    const value = isInverted ? (input.checked ? 0 : 1) : Number(input.checked);
    channel.sendControlChange(cc, value);
  });

  channel.sendControlChange(15, Number(ui.midiChannelSelect.value));
  channel.sendControlChange(16, Number(ui.bendUpSelect.value));
  channel.sendControlChange(17, Number(ui.bendDownSelect.value));
  channel.sendControlChange(18, Number(ui.ledBrightnessSelect.value));
  channel.sendControlChange(19, Number(ui.polyFatRangeSelect.value));

  setStatus("success", "Settings Sent", "Settings written to MEGAfm.");
}

function renderDeviceState(text) {
  ui.deviceState.textContent = text;
}

function updateFirmwareDisplay() {
  const major = state.firmware?.major;
  const minor = state.firmware?.minor;

  if (major == null && minor == null) {
    ui.firmwareValue.textContent = "-";
    return;
  }

  ui.firmwareValue.textContent = `${major ?? "?"}.${minor ?? "?"}`;
}

function setStatus(kind, badgeText, message) {
  ui.statusMessage.textContent = message;
}

function syncUiState() {
  const portsSelected = hasSelectedPorts();
  const midiInputsAvailable = state.midiReady && WebMidi.inputs.length > 0;
  const midiOutputsAvailable = state.midiReady && WebMidi.outputs.length > 0;

  ui.refreshPortsButton.disabled = !state.midiReady;
  ui.inputSelect.disabled = !midiInputsAvailable;
  ui.outputSelect.disabled = !midiOutputsAvailable;
  ui.readButton.disabled = !state.midiReady || !portsSelected;
  ui.writeButton.disabled = !state.midiReady || !portsSelected || !state.foundDevice;
}

function hasSelectedPorts() {
  return Boolean(getSelectedInput() && getSelectedOutput());
}

function getSelectedInput() {
  const id = ui.inputSelect.value;
  return WebMidi.inputs.find((input) => input.id === id) || null;
}

function getSelectedOutput() {
  const id = ui.outputSelect.value;
  return WebMidi.outputs.find((output) => output.id === id) || null;
}

function detachInputListener() {
  if (!state.listenerChannel) {
    return;
  }

  state.listenerChannel.removeListener("noteoff", handleDeviceReply);
  state.listenerChannel = null;
  state.awaitingReply = false;
}

function clearReplyTimeout() {
  if (state.replyTimeoutId === null) {
    return;
  }

  window.clearTimeout(state.replyTimeoutId);
  state.replyTimeoutId = null;
}

function scheduleReplyCompletion() {
  clearReplyTimeout();
  state.replyTimeoutId = window.setTimeout(() => {
    state.replyTimeoutId = null;
    detachInputListener();

    if (state.foundDevice) {
      setStatus("success", "Device Loaded", "Settings loaded.");
    }

    syncUiState();
  }, 500);
}
